<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24">
    <path
      d="M11.995 3C16.915 3 21 7.075 21 11.995 21 16.925 16.925 21 12.005 21 7.085 21 3 16.925 3 11.995 3 7.075 7.075 3 11.995 3zm-.009 1.688A7.278 7.278 0 0 0 4.687 12a7.28 7.28 0 0 0 7.308 7.313A7.282 7.282 0 0 0 19.313 12a7.307 7.307 0 0 0-7.327-7.313zM12 10.82c.487 0 .882.387.882.863v3.454l-.008.117A.876.876 0 0 1 12 16a.873.873 0 0 1-.882-.863v-3.454l.008-.117A.876.876 0 0 1 12 10.82zM12 8a.99.99 0 0 1 1 .978.99.99 0 0 1-1 .979.99.99 0 0 1-1-.979A.99.99 0 0 1 12 8z"
      :fill="color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#0071BB',
    },
    size: {
      type: String,
      default: '24',
    },
  },
}
</script>
